import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeterOcrService } from '../../services/meter-ocr.service';

@Component({
  selector: 'app-meter-ocr',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './MeterOcr.component.html',
  styleUrl: './MeterOcr.component.css',
})
export class MeterOcrComponent {
  constructor(private meterOcrService: MeterOcrService) {}

  imageUrl: string | ArrayBuffer | null = null;
  ocrResult: string = '';
  ocrLines: string[] = [];
  loading: boolean = false;

  // Enhancement options
  threshold: number = 128;
  invert: boolean = true;

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    const reader = new FileReader();
    reader.onload = async () => {
      this.loading = true;

      // Preprocess image
      const enhanced = await this.meterOcrService.enhanceImage(reader.result as string, this.threshold, this.invert);
      this.imageUrl = enhanced;

      // Run OCR
      const result = await this.meterOcrService.runTesseract(enhanced);
      this.ocrResult = result;;

      // Group into lines
      this.ocrLines = result.split('\n').map(l => l.trim()).filter(Boolean);

      const parsed = this.meterOcrService.parseMeterData(result);
      console.log('🔍 Parsed meter info:', parsed);

      this.loading = false;
    };
    reader.readAsDataURL(file);
  }
  // UI control helpers
  updateThreshold(value: number) {
    this.threshold = value;
  }

  toggleInvert() {
    this.invert = !this.invert;
  }
}
